import { render, staticRenderFns } from "./TeamsGrid.vue?vue&type=template&id=4894de34"
import script from "./TeamsGrid.vue?vue&type=script&lang=js"
export * from "./TeamsGrid.vue?vue&type=script&lang=js"
import style0 from "./TeamsGrid.vue?vue&type=style&index=0&id=4894de34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports